import { Injectable } from '@angular/core';
@Injectable()
export class GoogleAnalyticsEventsService {
  // declare let ga: Function;
  //ga: Function;

  public emitEvent(eventCategory: string,
                   eventAction: string,
                   eventLabel: string = null,
                   eventValue: number = null) {

  (<any>window).ga('send', 'event', {
      eventCategory: eventCategory,
      eventLabel: eventLabel,
      eventAction: eventAction,
      eventValue: eventValue
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/sharedcomponents/commonservice/googleAnalytics/google-analytics-events-service.service.ts